import { render } from "./ViewContacts.vue?vue&type=template&id=4954951d"
import script from "./ViewContacts.vue?vue&type=script&lang=js"
export * from "./ViewContacts.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__